'use client';
import Link from 'next/link';
import Image from 'next/image';
import { clsx } from 'clsx';
import { Button } from '@/components';
import { SvgArrowMore } from '@/components/icons';
import { API_URL, ENDPOINTS } from '@/utils/constants';
import { getYearsLabel } from '@/utils/strings';
import type { DoctorCardProps } from './doctorCard.types';
import s from './doctorCard.module.scss';
import { device } from '@/constants/mediaQuery';

export const DoctorCard = (props: DoctorCardProps) => {
  const {
    photo,
    experience,
    lastName,
    firstName,
    middleName,
    specialisations,
    category,
    minPrice,
    id,
    className,
  } = props;
  const photoUrl = `${API_URL}${ENDPOINTS.STATIC_FILES}${photo}`;
  const yearsLabel = getYearsLabel(experience);

  return (
    <Link href={`/doctors/${id}`} className={s.cardWrapper}>
      <div className={clsx(s.card, className)}>
        <div className={s.card__photoWrapper}>
          <Image
            src={photo ? photoUrl : '/withoutPhoto.png'}
            className={s.photo}
            alt="Фото врача"
            sizes={`${device.mobile} 340px, ${device.laptop} 352px, 295px`}
            fill
          />
        </div>
        {experience && (
          <div className={s.period} onClick={e => e.preventDefault()}>
            Стаж {experience} {yearsLabel}
          </div>
        )}
        <div className={s.cardText}>
          <div className={s.name} onClick={e => e.preventDefault()}>
            {lastName}<br />{firstName} {middleName}
          </div>
          <div className={s.specialisations} onClick={e => e.preventDefault()}>
            {specialisations?.length
              ? specialisations.map((specialisation, index) => {
                return (
                  <span key={specialisation.id}>
                    {specialisation.specialisation?.title}{index < specialisations.length - 1 && ', '}
                  </span>
                );
              })
              : <span>Специализация не указана</span>
            }
          </div>
          <div onClick={e => e.preventDefault()}>
            {category || <span>&nbsp;</span>}
          </div>
          {minPrice && <div className={s.price}>От {minPrice} руб.</div>}
        </div>
        <Button
          name="Подробнее"
          type="button"
          theme="outline"
          size="default"
          rightIcon={<SvgArrowMore />}
          className={s.button}
        />
      </div>
    </Link>
  );
};